import { withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bf-course-actions" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-fw fa-exclamation-triangle me-1" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Jetzt anmelden ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CourseEnrollmentModal = _resolveComponent("CourseEnrollmentModal")!
  const _component_CourseAppointmentsModal = _resolveComponent("CourseAppointmentsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.course.mode === _ctx.CourseMode.Closed)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_ctx.enrollment)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!_ctx.enrollment.waiting)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: "#",
                      class: "btn btn-sm btn-danger",
                      onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.enrollmentModalShown = true), ["prevent"]))
                    }, " Abmelden "))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!_ctx.course.participants_limit_reached)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "btn btn-sm btn-success",
                            href: "#",
                            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.enrollmentModalShown = true), ["prevent"]))
                          }, _hoisted_5))
                        : (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: "#",
                            class: "btn btn-sm btn-danger",
                            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.enrollmentModalShown = true), ["prevent"]))
                          }, " Warteliste "))
                    ], 64))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (!_ctx.course.participants_limit_reached)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "btn btn-sm btn-primary",
                      href: "#",
                      onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.enrollmentModalShown = true), ["prevent"]))
                    }, " Jetzt anmelden "))
                  : (_openBlock(), _createElementBlock("a", {
                      key: 1,
                      href: "#",
                      class: "btn btn-sm btn-secondary",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.enrollmentModalShown = true), ["prevent"]))
                    }, " Warteliste "))
              ])),
          _createVNode(_component_CourseEnrollmentModal, {
            course: _ctx.course,
            "course-enrollment": _ctx.enrollment,
            shown: _ctx.enrollmentModalShown,
            onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.enrollmentModalShown = false)),
            onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
          }, null, 8, ["course", "course-enrollment", "shown", "onEnrollmentStatusChange"])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createTextVNode(_toDisplayString('' /* Open courses can not have a participant limit anymore and also no direct enrollment (only to appointments) */) + " ", 1),
          _createElementVNode("a", {
            href: "#",
            class: "btn btn-sm btn-primary",
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.appointmentsModalShown = true), ["prevent"]))
          }, " Kurstermine "),
          _createVNode(_component_CourseAppointmentsModal, {
            course: _ctx.course,
            shown: _ctx.appointmentsModalShown,
            onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.appointmentsModalShown = false))
          }, null, 8, ["course", "shown"])
        ], 64))
  ]))
}